
import Carousel from "~/components/global/Carousel";
import Breadcrumbs from "~/components/global/Breadcrumbs";
import NewsAnnouncements from "~/components/global/NewsAnnouncements";
import NewsCards from "~/components/global/NewsCards";
export default {
    spacingDebug: false,
    components: {
        Carousel,
        Breadcrumbs,
        NewsAnnouncements,
        NewsCards,
    },
    props: {
        payload: {
            type: [Object, Array],
            default: () => ({}),
        },
    },
    computed: {
        latestNewsContent() {
            return {
                heading: { level: "h2", textContent: "Latest in the News", alignment: "center" },
                body: { items: this.payload?.latestNews || [] },
            };
        },
        carouselContent() {
            const hero = Array.isArray(this.payload?.hero) ? this.payload.hero.filter((slide) => slide && typeof slide === "object" && !Array.isArray(slide)) : [];
            const slides = hero.length ? hero : [{ id: "news-default-banner" }];
            return slides.map((slide) => {
                const images = Array.isArray(slide.images) ? slide.images : [];
                return {
                    ...slide,
                    images: ["image", "image_mobile"].map((category) => {
                        const image = images.find((image) => image?.category === category && image.type === "page_banner" && typeof image.path === "string" && image.path.trim());
                        return {
                            ...image,
                            category,
                            path: image?.path || "/assets/defaults/mico-banner-[light].webp",
                            alt: image?.alt || slide.title || "Malayan Insurance News",
                        };
                    }),
                    cta_btn_label: "See Latest News",
                    link: "#news-items",
                    is_anchor: true,
                    is_link_out: false,
                };
            });
        },
        newsContent() {
            return {
                heading: {
                    level: "h2",
                    textContent: "Featured News",
                    alignment: "center",
                },
                body: {
                    items: Array.isArray(this.payload?.recomendedNews) ? this.payload.recomendedNews : [],
                },
                cta: {
                    textContent: "See Latest News",
                    url: "#news-items",
                },
            };
        },
    },
};
